import { useState } from "react";
import Collapse from "../../components/Collapse/Collapse";
import SkillDatas from "../../datas/skills.json";
import expertise from "../../assets/images/expertise/expertise.png";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";
import AnimatedScrollItem from "../../components/AnimatedScrollItem/AnimatedScrollItem";

function Services() {
  const skillsToShow = SkillDatas.slice(0, 5); // Affiche les 5 premières compétences
  const skillsToShowTwo = SkillDatas.slice(5, 10); // Affiche les compétences suivantes (de 5 à 10)
  const [openCollapseIndex, setOpenCollapseIndex] = useState(null);

  const handleToggle = (uniqueId) => {
    setOpenCollapseIndex((prevId) => (prevId === uniqueId ? null : uniqueId));
  };

  return (
    <section id="services" className="skills">
      <div className="skill-content">
        <div className="section-heading text-center">
          <AnimatedScroll offset={50}>
            <h2 className="service_h2">Expertise🌟</h2>
          </AnimatedScroll>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="single-skill-content oneCollapse"></div>
              {skillsToShow.map((data, index) => {
                const uniqueId = `left-${index}`; // Identifiant unique pour la colonne de gauche
                return (
                  <AnimatedScrollItem key={data.id}>
                    <div className="barWrapper">
                      <Collapse
                        title={data.title}
                        logo={data.logo}
                        logo2={data.logo2}
                        altLogo={data.alt}
                        content={data.description}
                        isOpen={openCollapseIndex === uniqueId}
                        onToggle={() => handleToggle(uniqueId)}
                      />
                    </div>
                  </AnimatedScrollItem>
                );
              })}
            </div>

            <div className="col-md-6">
              <div className="single-skill-content"></div>
              {skillsToShowTwo.map((data, index) => {
                const uniqueId = `right-${index}`; // Identifiant unique pour la colonne de droite
                return (
                  <AnimatedScrollItem key={data.id}>
                    <div className="barWrapper">
                      <Collapse
                        title={data.title}
                        logo={data.logo}
                        logo2={data.logo2}
                        altLogo={data.alt}
                        content={data.description}
                        isOpen={openCollapseIndex === uniqueId}
                        onToggle={() => handleToggle(uniqueId)}
                      />
                    </div>
                  </AnimatedScrollItem>
                );
              })}
            </div>
          </div>
          <div className="end_expertise">
            <div className="section_text">
              <AnimatedScroll>
                <h3 className="h3_expertise">Pourquoi nous choisir ?</h3>
              </AnimatedScroll>

              <AnimatedScroll>
                <p className="p_expertise">
                  Notre agence combine créativité, technologie et stratégie pour
                  livrer des solutions qui vont au-delà de vos attentes. Nous
                  nous engageons à offrir des résultats mesurables, tout en vous
                  guidant tout au long du processus. Que vous soyez une petite
                  entreprise ou une grande marque, notre expertise est à votre
                  service pour faire évoluer votre présence en ligne.
                </p>
              </AnimatedScroll>
            </div>
            <AnimatedScroll>
              <img
                className="img_expertise"
                alt="expertise pc"
                src={expertise}
              />
            </AnimatedScroll>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
